// extracted by mini-css-extract-plugin
module.exports = {"sun":"styles_sun__vyC8X","loading-wheel":"styles_loading-wheel__Dv4Hu"};